/**
 * Brisato loader (snippets/loader.liquid). window.brisatoLoader(box) puts the
 * logo sweep inside box after 0.3 s and returns a function that removes it, so
 * a fast answer never flashes it. The logo is fetched once the page is idle,
 * so it is ready the first time it is needed.
 */
(() => {
  const template = document.getElementById('BrisatoLoader');
  if (!template) return;

  window.brisatoLoader = (box, delay = 300) => {
    let node = null;
    const timer = window.setTimeout(() => {
      node = template.content.firstElementChild.cloneNode(true);
      box.prepend(node);
    }, delay);
    return () => {
      window.clearTimeout(timer);
      if (node) node.remove();
    };
  };

  const warm = () => {
    const img = template.content.querySelector('img');
    if (img) new Image().src = img.src;
  };
  if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 4000 });
  else window.setTimeout(warm, 3000);
})();
